<template>
    <div class="row">
        <div class="col-12">
            <ibox :title="'Przymierzalnia'">
                <!-- <template slot="tools">
                    <router-link to="/porownywarka/dodaj" class="btn btn-primary btn-xs">
                        Dodaj nową bazę
                        <i class="fas fa-plus"></i>
                    </router-link>
                </template> -->
                <template slot="content" slot-scope="{ setLoading }">
                    <data-tables
                        :url="`vnfr/${$route.params.env}/wishlists/list`"
                        :columns_list="columns_list"
                        @loading="setLoading"
                    />
                </template>
            </ibox>
        </div>
    </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import DataTables from '@/components/DataTables'

export default {
    name: 'WishList',
    components: {
        Ibox,
        DataTables
    },
    data() {
        return {
            excel: true,
            columns_list: [
                // {
                //     key: 'id',
                //     name: this.$t( 'edit' ),
                //     filter: 'btn',
                //     btn: a => `<a href="#/przymierzalnia/${this.$route.params.env}/lista-zyczen/${a}"><i class="fa fa-edit"></i></a>`
                // },
                {
                    key: 'app_id',
                    name: 'Id App',
                    type: 'text',
                    sortable: true
                },
                {
                    key: 'created_at',
                    name: 'Utworzono',
                    type: 'text',
                    sortable: true
                },
                {
                    key: 'deleted_at',
                    name: 'Usunięto',
                    type: 'text',
                    sortable: true
                },
                {
                    key: 'name',
                    name: 'Nazwa',
                    type: 'text',
                    sortable: true
                },
                {
                    key: 'plum',
                    name: 'Plum',
                    type: 'text',
                    sortable: true
                }
            ]
        }
    }
}
</script>
